import React, { useState } from 'react';
import { api, getTenant, getUserName } from '../../../hooks';
import { IBLSpinLoader } from '../../IBLSpinLoader';

const LinkUpload = ({ setLinks, links }) => {
  const [link, setLink] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const isValidURL = (url) => {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
      '((([a-zA-Z0-9\\-]+\\.)+[a-zA-Z]{2,})|' + // domain name
      'localhost|' + // localhost
      '(([0-9]{1,3}\\.){3}[0-9]{1,3}))' + // OR ip (v4) address
      '(\\:[0-9]{1,5})?' + // port
      '(\\/.*)?$', // path
      'i'
    );
    return !!pattern.test(url);
  };

  const handleSubmit = () => {
    if (link && isValidURL(link)) {
      const formData = new FormData();
      formData.append(`link_${links.length + 1}`, link); // Append the link instead of a file
      // append all the other links from the links array
      links.forEach((link, index) => {
        formData.append(`link_${index + 1}`, link?.url);
      });
      formData.append('user', getUserName());
      const DEFAULT_TENANT_TO_USE = process.env.REACT_APP_IBL_PROFILE_RESUME_FEATURE_TENANT_TO_USE_WITH_ENDPOINTS ?? getTenant()
      formData.append('platform', DEFAULT_TENANT_TO_USE);

      setIsUploading(true);
      setErrorMessage('');
      api.ibldmplatform.putUserResume(
        { org: DEFAULT_TENANT_TO_USE, userID: getUserName() },
        formData,
        (data) => {
          setIsUploading(false);
          setLink(''); // Clear the input after successful upload
          setErrorMessage('');
          setLinks(data?.links || []);
        },
        (error) => {
          setIsUploading(false);
          window.alert('Error uploading link. Please try again later.');
          console.error(error);
        }
      );
    } else {
      window.alert('Please enter a valid URL.');
    }
  };

  return (
    <div className="w-layout-vflex flex-block-54">
      {isUploading ? (
        <IBLSpinLoader size={40} />
      ) : (
        <>
          <div className="form-block-29 w-form">
            <form
              id="link-upload-form"
              name="link-upload-form"
              data-name="Link Upload Form"
              method="get"
              className="form-19"
              aria-label="Link Upload Form"
            >
              <input
                className="text-field-21 w-input"
                maxLength={256}
                name="link"
                placeholder="Enter Media URL"
                type="text"
                value={link}
                onChange={(e) => setLink(e.target.value)}
                id="link"
              />
            </form>
          </div>
{/* 
          {errorMessage && (
            <div style={{ color: 'red', marginTop: '10px' }}>
              {errorMessage}
            </div>
          )} */}

          <a href="#" className="button-7 w-button" onClick={handleSubmit}>
            Upload
          </a>
        </>
      )}
    </div>
  );
};

export default LinkUpload;
